import { PRICE_LADDER_MODEL  } from './constant';

export const priceLadderDataLoader = (payload) => {
  return {
    type: PRICE_LADDER_MODEL,
    payload,
  };
}; 